<!-- <app-modal></app-modal> -->
<app-navbar-style-three></app-navbar-style-three>

<div class="fixed-button" style="font-family: 'Li Ador Noirrit SemiBold';">
  <a href="online-admission" target="_blank" routerLinkActive="active" class="btn">
    অনলাইন ভর্তি
  </a>
</div>

<div class="marquee-container" style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 21px">
  <div class="col-md-auto" style=" text-align: center; padding: 5px;">
  </div>
  <div style="width: 87%">
    <marquee behavior="scroll" direction="left" style="cursor: pointer;" onmouseover="this.stop();"
      onmouseleave="this.start();">
      <div style="display: inline-block; position: relative; top: 6px;">
        <ng-container *ngIf="Notices.length ==0">
          <a class="scroll-text" style="font-family: 'Li Ador Noirrit SemiBold'; padding: 0 15px;">No Notices Found</a>
        </ng-container>
        <ng-container *ngIf="Notices.length !=0">
          <span *ngFor="let data of Notices" style="margin-right: 30px;">
            <a (click)="onNavigate(data.FileLink)" class="scroll-text">{{data.EnglishTitle}}</a>
          </span>
        </ng-container>
      </div>
    </marquee>
  </div>
</div>
<!--Notice Scroll -->
<div class="bg1" style="font-family: 'Li Ador Noirrit SemiBold';">
  <section class="about-area" style="padding: 10px 0 0 0 ;">
    <div class="container" style="margin-bottom: 30px;">
      <div class="row parent">
        <div class="col-12 col-lg-8 col-md-12 mb-4">
          <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner mainCarousel-inner" style="height: 475px !important;">

              <div class="carousel-item mainCarouel-item" *ngFor="let slide of slides; let i = index"
                [class.active]="i === 0">
                <img [src]="slide.ImageLink" class="d-block w-100 "
                  style="height: 475px !important;border: 5px solid #26551f;border-radius: 2%;"
                  alt="Slide {{ i + 1 }}" />
              </div>

            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12">
          <section class="widget establishment widget_karlson_posts_thumb" style="
         height: 475px;
 
  
 
  padding-bottom: 0;
  border-radius: 2%;
">
            <article class="item text-center">
              <h4 class="widget-title"
                style="padding-bottom: 0px;padding-top: 60px;font-family: 'Li Ador Noirrit SemiBold';">প্রতিষ্ঠাতা ও
                পৃষ্ঠপোষক</h4>

              <div style="padding-bottom: 5px; position: relative;">

                <!-- Carousel Wrapper -->
                <div style="overflow: hidden; border-radius: 8px; position: relative;">




                  <!-- Track -->
                  <div #pdTrack style="display: flex; transition: transform 0.4s ease;">

                    <div *ngFor="let person of founders" style="
            min-width: 100%; display: flex; flex-direction: column;
            align-items: center; padding: 16px 0 24px;">

                      <div style="
              width: 200px; height: 300px; border-radius: 8px;
              overflow: hidden; border: 1px solid #eee;
              background: #f9f9f9; display: flex;
              align-items: center; justify-content: center;margin-top: -20px;">
                        <img [src]="person.image" [alt]="person.name"
                          style="width: 100%; height: 100%; object-fit: cover;" />
                      </div>

                      <p
                        style="font-size: 16px; font-weight: 500; margin: 0;padding-top: 28px;margin-top: -20px;font-family: congenial;">
                        {{ person.name }}
                      </p>

                    </div>
                  </div>

                </div>

                <!-- Dots -->
                <!-- <div style="display: flex; justify-content: center; gap: 6px; margin-top: -8px;">
        <span *ngFor="let p of founders; let i = index"
          (click)="pdGoTo(i)"
          [style.background]="i === pdCurrent ? '#555' : '#ccc'"
          style="width: 7px; height: 7px; border-radius: 50%; cursor: pointer; display: inline-block;">
        </span>
      </div> -->

              </div>
            </article>
          </section>








        </div>



      </div>
    </div>
  </section>

  <section class="about-area" style="padding: 20px 0 0 0;">
    <div class="container">
      <div class="row parent">
        <div class="col-lg-7 col-md-12 message">
          <aside class="widget-area">
            <section class="widget widget_karlson_posts_thumb" style="height: auto;">
              <h4
                style="text-align: center; font-weight: bold; font-size: 25px; color: black;font-family: 'Li Ador Noirrit SemiBold';">
                স্বাগত বার্তা
              </h4>
              <h2
                style="color: #026670; text-align: center; border-bottom: 1px solid #9fedd7; padding-top: 5px;font-family: Congenial;">
                {{ MainData?.Name}}
              </h2>
              <h5 style="text-align: center; color: black;font-family: 'Li Ador Noirrit SemiBold';">বিসমিল্লাহির
                রাহমানির রাহীম</h5>
              <div *ngIf="MainData != null">
                <ng-container *ngIf="HomeContent != null">
                  <p style="color: black !important; text-align: justify !important;" data-aos="zoom-in">
                    <ng-container *ngIf="showFullContent; else partialContent">
                      <span [innerHTML]="HomeContent[0].DetailsEn"></span>
                      <br />
                      <button style="border: 1px solid;" (click)="toggleShowContent()" class="btn readMoreLess-btn">
                        সংক্ষিপ্ত
                      </button>
                    </ng-container>
                    <ng-template #partialContent>

                      <span [innerHTML]="truncateText(HomeContent[0].DetailsEn, 985)"></span>


                      <br />
                      <button style="border: 1px solid;margin-top: 10px;" (click)="toggleShowContent()"
                        class="btn readMoreLess-btn">
                        বিস্তারিত...
                      </button>
                    </ng-template>
                  </p>
                </ng-container>
              </div>
            </section>
          </aside>
        </div>
        <div class="col-lg-5 col-md-12 child">
          <div class="widget-area">
            <section class="widget widget_karlson_posts_thumb">
              <h3 class="widget-title"
                style="color: #026670; font-family: 'Li Ador Noirrit SemiBold'; margin-top: 3px;">
                নোটিশ বোর্ড
              </h3>
              <div class="tab-container" style="font-family: Li Ador Noirrit SemiBold !important;margin-bottom: -30px;">
                <ul class="nav nav-pills" id="myTab" role="tablist"
                  style="font-family: 'Li Ador Noirrit SemiBold !important'">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active tabsButton" (click)="filterNotices('all')"
                      data-bs-target="#content-1" type="button" role="tab" aria-controls="content-1"
                      aria-selected="true">
                      সকল
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link tabsButton" (click)="filterNotices('Ibtedayi')" data-bs-target="#content-2"
                      type="button" role="tab" aria-controls="content-2" aria-selected="false">
                      ইবতেদায়ী
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link tabsButton" (click)="filterNotices('Dhakil')" data-bs-target="#content-3"
                      type="button" role="tab" aria-controls="content-3" aria-selected="false">
                      দাখিল
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link tabsButton" (click)="filterNotices('Karigari')" data-bs-target="#content-4"
                      type="button" role="tab" aria-controls="content-4" aria-selected="false">
                      কারিগরি
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link tabsButton" (click)="filterNotices('Administrative')"
                      data-bs-target="#content-5" type="button" role="tab" aria-controls="content-5"
                      aria-selected="false">
                      প্রশাসনিক
                    </button>
                  </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="content-1" role="tabpanel" aria-labelledby="সকল">
                    <article class="item">
                      <div class="ticker-wrapper-v-image">
                        <ul class="news-ticker-v-image" *ngIf="filteredNotices.length === 0">
                          <li style="border: 1px solid #eeeeee; padding: 5px">
                            <div>
                              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                <span style="font-family: 'Congenial';">No Notices Found</span>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </li>
                        </ul>
                        <ul class="news-ticker-v-image" *ngIf="filteredNotices.length > 0">
                          <li *ngFor="let item of filteredNotices" style="border: 1px solid #eeeeee; padding: 5px">
                            <div class="thumbnail" style="font-family: 'Congenial' !important;">
                              <div style="border: 1px solid #eeeeee; width: 80px">
                                <div style="background-color: #026670" class="text-center">
                                  <span style="text-align: center; color: #ffffff">
                                    {{ item.CreatedDate | date:'dd' }}
                                  </span>
                                </div>
                                <div style="background-color: #f2f2f2" class="text-center">
                                  <span style="text-align: center; color: #026670">
                                    {{ item.CreatedDate | date:'MMM' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div
                                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer;font-family: 'Congenial';">
                                {{ item.EnglishTitle }}
                              </div>
                              <div style="overflow: auto">
                                <a (click)="onNavigate(item.FileLink)"
                                  style="text-decoration: unset; color: #151574; cursor: pointer;">
                                  <span style="font-family: 'Congenial';">View Notice</span>
                                </a>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </li>
                        </ul>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <!-- <button  href="/notice" class="viewAll" style="
            color: #026670 !important;
            text-align: right;
            margin-top: -30px !important;
            font-family: 'Li Ador Noirrit SemiBold';
          "><i class="fa fa-bars"></i>সকল নোটিশ দেখুন</button> -->
          <a href="/notice" class="viewAll" style="
            color: #026670 !important;
            text-align: right;
           
            font-family: 'Li Ador Noirrit SemiBold';
          "><i class="fa fa-bars"></i> সকল নোটিশ দেখুন
          </a>

        </div>
      </div>
    </div>
  </section>


  <!-- Start Messages -->

  <section class="about-area" style="padding: 20px 0 0 0;">

    <div class="container" style="padding: 20px 16px;">
      <div class="row justify-content-center g-4">

        <!--  বার্তা -->
        <div class="col-12 col-lg-4 col-md-12">
          <div class="cpap">
            <ng-container *ngFor="let item of GBMessageShown">
              <div *ngIf="item.GBDesignationId == 49" class="d-flex flex-column h-100">
                <div style="text-align: center; margin-top: 10px;">
                  <img [src]="item.GBImagePath" alt="image" style="width: 200px; height: 250px; object-fit: cover;
                                   border-radius: 8px; border: 3px solid #ffffff55;">
                  <p style="color: black; font-weight: bold; margin-top: 10px;
                                 font-family: 'Li Ador Noirrit SemiBold'; font-size: 15px;">
                    {{ item.GBName || item.NameBn }}
                  </p>
                  <p style="color: black; font-size: 13px; margin-top: -8px;
                                font-family: 'Li Ador Noirrit SemiBold';">
                    {{ item.TitleEn }}
                  </p>
                </div>

                <p style="text-align: justify; font-size: 15px; color: black;
                             line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                  [innerHTML]="getShortText(item.DetailsEn, 250)">
                </p>

                <div style="text-align: center; margin-top: auto; padding-top: 15px;">
                  <button (click)="onNavigateMessage(item?.GBDesignationName, item)" style="background: transparent; border: 1px solid black;
                                       color: black; padding: 6px 20px; border-radius: 6px;
                                       cursor: pointer; font-size: 16px; 
                                       font-family: 'Li Ador Noirrit SemiBold';
                                       transition: all 0.3s ease;">
                    বিস্তারিত পড়ুন
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12">
          <div class="cpap">
            <ng-container *ngFor="let item of GBMessageShown">
              <div *ngIf="item.GBDesignationId == 110" class="d-flex flex-column h-100">
                <div style="text-align: center; margin-top: 10px;">
                  <img [src]="item.GBImagePath" alt="image" style="width: 200px; height: 250px; object-fit: cover;
                                   border-radius: 8px; border: 3px solid #ffffff55;">
                  <p style="color: black; font-weight: bold; margin-top: 10px;
                                 font-family: 'Li Ador Noirrit SemiBold'; font-size: 15px;">
                    {{ item.GBName || item.NameBn }}
                  </p>
                  <p style="color: black; font-size: 13px; margin-top: -8px;
                                font-family: 'Li Ador Noirrit SemiBold';">
                    {{ item.TitleEn }}
                  </p>
                </div>

                <p style="text-align: justify; font-size: 15px; color: black;
                             line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                  [innerHTML]="getShortText(item.DetailsEn, 250)">
                </p>

                <div style="text-align: center; margin-top: auto; padding-top: 15px;">
                  <button (click)="onNavigateMessage(item?.GBDesignationName, item)" style="background: transparent; border: 1px solid black;
                                       color: black; padding: 6px 20px; border-radius: 6px;
                                       cursor: pointer; font-size: 16px; 
                                       font-family: 'Li Ador Noirrit SemiBold';
                                       transition: all 0.3s ease;">
                    বিস্তারিত পড়ুন
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12">
          <div class="cpap">
            <ng-container *ngFor="let item of GBMessageShown">
              <div *ngIf="item.GBDesignationId == 58" class="d-flex flex-column h-100">
                <div style="text-align: center; margin-top: 10px;">
                  <img [src]="item.GBImagePath" alt="image" style="width: 200px; height: 250px; object-fit: cover;
                                   border-radius: 8px; border: 3px solid #ffffff55;">
                  <p style="color: black; font-weight: bold; margin-top: 10px;
                                 font-family: 'Li Ador Noirrit SemiBold'; font-size: 15px;">
                    {{ item.GBName || item.NameBn }}
                  </p>
                  <p style="color: black; font-size: 13px; margin-top: -8px;
                                font-family: 'Li Ador Noirrit SemiBold';">
                    {{ item.TitleEn }}
                  </p>
                </div>

                <p style="text-align: justify; font-size: 15px; color: black;
                             line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                  [innerHTML]="getShortText(item.DetailsEn, 250)">
                </p>

                <div style="text-align: center; margin-top: auto; padding-top: 15px;">
                  <button (click)="onNavigateMessage(item?.GBDesignationName, item)" style="background: transparent; border: 1px solid black;
                                       color: black; padding: 6px 20px; border-radius: 6px;
                                       cursor: pointer; font-size: 16px; 
                                       font-family: 'Li Ador Noirrit SemiBold';
                                       transition: all 0.3s ease;">
                    বিস্তারিত পড়ুন
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12">
          <div class="cpap">
            <ng-container *ngFor="let item of GBMessageShown">
              <div *ngIf="item.GBDesignationId == 6" class="d-flex flex-column h-100">
                <div style="text-align: center; margin-top: 10px;">
                  <img [src]="item.GBImagePath" alt="image" style="width: 200px; height: 250px; object-fit: cover;
                                   border-radius: 8px; border: 3px solid #ffffff55;">
                  <p style="color: black; font-weight: bold; margin-top: 10px;
                                 font-family: 'Li Ador Noirrit SemiBold'; font-size: 15px;">
                    {{ item.GBName || item.NameBn }}
                  </p>
                  <p style="color: black; font-size: 13px; margin-top: -8px;
                                font-family: 'Li Ador Noirrit SemiBold';">
                    {{ item.TitleEn }}
                  </p>
                </div>

                <p style="text-align: justify; font-size: 15px; color: black;
                             line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                  [innerHTML]="getShortText(item.DetailsEn, 250)">
                </p>

                <div style="text-align: center; margin-top: auto; padding-top: 15px;">
                  <button (click)="onNavigateMessage(item?.GBDesignationName, item)" style="background: transparent; border: 1px solid black;
                                       color: black; padding: 6px 20px; border-radius: 6px;
                                       cursor: pointer; font-size: 16px; 
                                       font-family: 'Li Ador Noirrit SemiBold';
                                       transition: all 0.3s ease;">
                    বিস্তারিত পড়ুন
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-md-12">
          <div class="cpap">
            <ng-container *ngFor="let item of GBMessageShown">
              <div *ngIf="item.GBDesignationId == 12" class="d-flex flex-column h-100">
                <div style="text-align: center; margin-top: 10px;">
                  <img [src]="item.GBImagePath" alt="image" style="width: 200px; height: 250px; object-fit: cover;
                                   border-radius: 8px; border: 3px solid #ffffff55;">
                  <p style="color: black; font-weight: bold; margin-top: 10px;
                                 font-family: 'Li Ador Noirrit SemiBold'; font-size: 15px;">
                    {{ item.GBName || item.NameBn }}
                  </p>
                  <p style="color: black; font-size: 13px; margin-top: -8px;
                                font-family: 'Li Ador Noirrit SemiBold';">
                    {{ item.TitleEn }}
                  </p>
                </div>

                <p style="text-align: justify; font-size: 15px; color: black;
                             line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                  [innerHTML]="getShortText(item.DetailsEn, 250)">
                </p>

                <div style="text-align: center; margin-top: auto; padding-top: 15px;">
                  <button (click)="onNavigateMessage(item?.GBDesignationName, item)" style="background: transparent; border: 1px solid black;
                                       color: black; padding: 6px 20px; border-radius: 6px;
                                       cursor: pointer; font-size: 16px; 
                                       font-family: 'Li Ador Noirrit SemiBold';
                                       transition: all 0.3s ease;">
                    বিস্তারিত পড়ুন
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>


      </div>
    </div>

  </section>

  <!-- Message Modal -->
  <div class="modal" [style.display]="showMessageModal ? 'block' : 'none'" style="background-color: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-lg message-modal">


      <div class="modal-content message-modal-content">

        <h5 class="modal-title" style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 22px;">
          {{ selectedMessage?.GBName || selectedMessage?.NameBn || selectedMessage?.TitleEn }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeMessageModal()"
          style="filter: brightness(1.2);"></button>


        <div class="modal-body message-modal-body">
          <div style="padding: 0px 25px 10px 25px;">
            <div style="padding-top: 10px;">
              <p style="text-align: justify; color: #333; line-height: 1.8; font-family: 'Li Ador Noirrit SemiBold';"
                [innerHTML]="selectedMessage?.DetailsEn">
              </p>
              <div class="modal-footer" style=" background-color: transparent;">
                <button type="button" class="btn btn-secondary" (click)="closeMessageModal()"
                  style="font-family: 'Li Ador Noirrit SemiBold'; background-color: #295b82; border: none;">
                  বন্ধ করুন
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- end Messages -->



  <section class="featured-services-area" style="padding: 20px 0 0 0">
    <div class="container" style="font-family: 'Li Ador Noirrit SemiBold';">
      <div class="section-title">
        <!-- <h4
                    style="text-align: center; font-family: 'Congenial'; font-weight: normal; font-size: 30px !important;">
                    Faculties</h4> -->
        <h3 style="
            color: #01434a;
            font-size: 38px;
            font-weight: bold;
            text-align: center;
            padding-top: 20px;
            font-family: 'Li Ador Noirrit SemiBold';
          ">
          শিক্ষার্থীদের জন্য আমাদের কোর্সসমূহ
        </h3>
      </div>

      <div class="continuous-carousel" style="padding: 0px 0 0 0;margin-top: -20px;">
        <div class="continuous-carousel-track">
          <!-- First set of items -->
          <ng-container *ngTemplateOutlet="cardList"></ng-container>
          <!-- Duplicate set for infinite scroll -->
          <ng-container *ngTemplateOutlet="cardList"></ng-container>
        </div>
      </div>

      <ng-template #cardList>
        <div class="marquee-item">
          <div class="" style="border: black 2px solid;border-radius: 10px;">
            <div class="single-featured-box"
              style="margin: 10px;height: 223px; display: flex; flex-direction: column; justify-content: space-between; align-items: center; padding-bottom: 20px;">
              <div class="icon" style="padding-top: 10px;">
                <img style="height: 80px;padding-top: 10px;" src="assets/img/school/faculties/1.png" alt="হিফজ বিভাগ" />
              </div>
              <h5 style="color: white; text-align: center; margin: 0;">হিফজ বিভাগ</h5>
              <a routerLink="/hefz" class="default-btn">বিস্তারিত</a>
            </div>
          </div>
        </div>

        <div class="marquee-item">
          <div class="" style="border: black 2px solid;border-radius: 10px;">
            <div class="single-featured-box"
              style="margin: 10px;height: 223px; display: flex; flex-direction: column; justify-content: space-between; align-items: center; padding-bottom: 20px;">
              <div class="icon" style="padding-top: 10px;">
                <img style="height: 80px;padding-top: 10px;" src="assets/img/school/faculties/2.png" alt="ইবতেদায়ী" />
              </div>
              <h5 style="color: white; text-align: center; margin: 0;">ইবতেদায়ী</h5>
              <a routerLink="/ebtedayee" class="default-btn">বিস্তারিত</a>
            </div>
          </div>
        </div>

        <div class="marquee-item">
          <div class="" style="border: black 2px solid;border-radius: 10px;">
            <div class="single-featured-box"
              style="margin: 10px;height: 223px; display: flex; flex-direction: column; justify-content: space-between; align-items: center; padding-bottom: 20px;">
              <div class="icon color-facd60" style="padding-top: 10px;">
                <img style="height: 80px;padding-top: 10px;" src="assets/img/school/faculties/3.png"
                  alt="দাখিল (সাধারণ ও বিজ্ঞান)" />
              </div>
              <h5 style="color: #ddd; text-align: center; margin: 0;">দাখিল (সাধারণ ও বিজ্ঞান)</h5>
              <a routerLink="/dakhil-general-and-science" class="default-btn">বিস্তারিত</a>
            </div>
          </div>
        </div>

        <div class="marquee-item">
          <div class="" style="border: black 2px solid;border-radius: 10px;">
            <div class="single-featured-box"
              style="margin: 10px 10px 8px 10px;height: 223px; display: flex; flex-direction: column; justify-content: space-between; align-items: center; padding-bottom: 20px;">
              <div class="icon color-1ac0c6" style="padding-top: 10px;">
                <img style="height: 80px;padding-top: 10px;" src="assets/img/school/faculties/4.png"
                  alt="কারিগরি শিক্ষা" />
              </div>
              <h5 style="color: #ddd; text-align: center; margin: 0;">কারিগরি শিক্ষা</h5>
              <a routerLink="/karigori-shiksha" class="default-btn">বিস্তারিত</a>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </section>
  <section class="about-area" style="padding: 20px 0 0 0">
    <div class="container">
      <div class="section-title">
        <!-- <h4
                    style="text-align: center; font-family: 'Congenial'; font-weight: normal; font-size: 30px !important;">
                    Activites</h4> -->
        <h3 style="
            color: #01434a;
            font-size: 38px;
            font-weight: bold;
            text-align: center;
            padding-top: 20px;
            font-family: 'Li Ador Noirrit SemiBold';
          ">
          অন্যান্য কার্যক্রম
        </h3>

      </div>
      <div class="row justify-content-center" style="padding: 0px 0 0 0;margin-top: -20px;">
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/department-of-literature-and-culture">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;
             
            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/1.png" alt="সাহিত্য-সংস্কৃতি বিভাগ" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  সাহিত্য-সংস্কৃতি বিভাগ
                </h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/department-of-computer-and-ict">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;

            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/2.png" alt="কম্পিউটার ও আইসিটি বিভাগ" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  কম্পিউটার ও আইসিটি বিভাগ
                </h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/student-welfare-department">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;
        
            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/3.png" alt="শিক্ষার্থী কল্যাণ বিভাগ" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  শিক্ষার্থী
                  কল্যাণ বিভাগ
                </h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/student-welfare-department">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;
             
            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/4.png" alt="উচ্চ শিক্ষায় উৎসাহ ও সহযোগিতা" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  উচ্চ
                  শিক্ষায় উৎসাহ ও <br> সহযোগিতা
                </h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/mtts-blood-bank">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;
            
            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/5.png" alt="{{MainData?.Name}} ব্লাড ব্যাংক" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  ব্লাড ব্যাংক
                </h3>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3 col-sm-6">
          <a routerLink="/our-achievement">
            <div class="service-card-one center light-reflection" style="
              background-color: transparent;
              border: 2px solid black;
             
            ">
              <div class="clubs">
                <div class="icon" style="padding-top: 30px;">
                  <img src="assets/img/school/clubs/6.png" alt="আমাদের অর্জন" />
                </div>
                <h3 style="text-transform: uppercase;color:white; font-family: 'Li Ador Noirrit SemiBold'">
                  আমাদের
                  অর্জন
                </h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>













  <section class="about-area" style="padding: 20px 0 0 0">
    <div class="container">
      <div class="section-title">
        <h3
          style="color: #01434a; font-size: 38px; font-weight: bold; text-align: center; padding-top: 5px;font-family: 'Li Ador Noirrit SemiBold';">
          সেবা
          সমূহ</h3>
      </div>

      <div class="row g-3" style="margin-top: -20px;">

        <!-- Card 1 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="svc-card"
            style="background:#fff; border:0.5px solid #ddd; border-radius:12px; overflow:hidden; transition:transform 0.18s, box-shadow 0.18s;"
            onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(2,102,112,0.13)'"
            onmouseout="this.style.transform='';this.style.boxShadow=''">
            <div
              style="background:#026670; padding:14px 12px 12px; display:flex; flex-direction:column; align-items:center; gap:10px;">
              <div
                style="width:60px; height:60px; border-radius:50%; overflow:hidden; display:flex; align-items:center; justify-content:center;">
                <img src="../../../../assets/img/school/download.jpg"
                  style="width:100%; height:100%; object-fit:cover;">
              </div>
              <h3 style="margin:0; font-size:13px; font-weight:500; color:#fff; text-align:center; line-height:1.4;">
                মাদ্রাসা শিক্ষা অধিদপ্তর</h3>
              <p
                style="margin:0; font-size:10px; color:rgba(255,255,255,0.65); text-align:center; font-family: 'Congenial';">
                Directorate of Madrasa Education</p>
            </div>
            <div>
              <a href="https://dme.gov.bd/" target="_blank" class="svc-link"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                DME পোর্টাল
                <span
                  style="margin-left:auto; font-size:9px; padding:1px 6px; border-radius:99px; background:rgba(2,102,112,0.1); color:#026670; font-family: 'Congenial';">Official</span>
                <span style="font-size:11px; color:#aaa;">↗</span>
              </a>
              <a href="https://memis.gov.bd/" target="_blank"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                MEMIS সিস্টেম
                <span
                  style="margin-left:auto; font-size:9px; padding:1px 6px; border-radius:99px; background:rgba(2,102,112,0.1); color:#026670; font-family: 'Congenial';">Official</span>
                <span style="font-size:11px; color:#aaa;">↗</span>
              </a>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div
            style="background:#fff; border:0.5px solid #ddd; border-radius:12px; overflow:hidden; transition:transform 0.18s, box-shadow 0.18s;"
            onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(2,102,112,0.13)'"
            onmouseout="this.style.transform='';this.style.boxShadow=''">
            <div
              style="background:#026670; padding:14px 12px 12px; display:flex; flex-direction:column; align-items:center; gap:10px;">
              <div
                style="width:60px; height:60px; border-radius:50%; overflow:hidden; display:flex; align-items:center; justify-content:center;">
                <img src="../../../../assets/img/school/images.jpg" style="width:100%; height:100%; object-fit:cover;">
              </div>
              <h3 style="margin:0; font-size:13px; font-weight:500; color:#fff; text-align:center; line-height:1.4;">
                মাদ্রাসা শিক্ষা বোর্ড</h3>
              <p
                style="margin:0; font-size:10px; color:rgba(255,255,255,0.65); text-align:center; font-family: 'Congenial';">
                Madrasa Education Board</p>
            </div>
            <div>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                ইবতেদায়ী <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                দাখিল <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                কওমী <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div
            style="background:#fff; border:0.5px solid #ddd; border-radius:12px; overflow:hidden; transition:transform 0.18s, box-shadow 0.18s;"
            onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(2,102,112,0.13)'"
            onmouseout="this.style.transform='';this.style.boxShadow=''">
            <div
              style="background:#026670; padding:14px 12px 12px; display:flex; flex-direction:column; align-items:center; gap:10px;">
              <div
                style="width:60px; height:60px; border-radius:50%;  overflow:hidden; display:flex; align-items:center; justify-content:center;">
                <img src="../../../../assets/img/school/iau.jpeg" style="width:100%; height:100%; object-fit:cover;">
              </div>
              <h3 style="margin:0; font-size:13px; font-weight:500; color:#fff; text-align:center; line-height:1.4;">
                ইসলামি আরবি বিশ্ববিদ্যালয়</h3>
              <p
                style="margin:0; font-size:10px; color:rgba(255,255,255,0.65); text-align:center; font-family: 'Congenial';">
                Islamic Arabic University</p>
            </div>
            <div>
              <a href="https://iau.edu.bd/" target="_blank"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee; font-family: 'Congenial';">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                IAU ওয়েবসাইট
                <span
                  style="margin-left:auto; font-size:9px; padding:1px 6px; border-radius:99px; background:rgba(2,102,112,0.1); color:#026670; font-family: 'Congenial';">Official</span>
                <span style="font-size:11px; color:#aaa;">↗</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                শরীয়াহ বিভাগ <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                হাদিস বিভাগ <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
            </div>
          </div>
        </div>

        <!-- Card 4 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div
            style="background:#fff; border:0.5px solid #ddd; border-radius:12px; overflow:hidden; transition:transform 0.18s, box-shadow 0.18s;"
            onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(2,102,112,0.13)'"
            onmouseout="this.style.transform='';this.style.boxShadow=''">
            <div
              style="background:#026670; padding:14px 12px 12px; display:flex; flex-direction:column; align-items:center; gap:10px;">
              <div
                style="width:60px; height:60px;border-radius: 50%;  overflow:hidden; display:flex; align-items:center; justify-content:center;">
                <img src="../../../../assets/img/school/4th logo of  bottom top of footer.jpg"
                  style="width:100%; height:100%; object-fit:cover;">
              </div>
              <h3 style="margin:0; font-size:12px; font-weight:500; color:#fff; text-align:center; line-height:1.4;">
                আঞ্জুমান-ই-রহমানিয়া আহমদিয়া সুন্নিয়া ট্রাস্ট</h3>
              <p
                style="margin:0; font-size:10px; color:rgba(255,255,255,0.65); text-align:center; font-family: 'Congenial';">
                Anjuman Trust</p>
            </div>
            <div>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                সাইট ভিজিট <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px; border-bottom:0.5px solid #eee;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                ডোনেশন <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
              <a href="#"
                style="display:flex; align-items:center; gap:8px; padding:9px 14px; text-decoration:none; color:#333; font-size:12.5px;">
                <span
                  style="width:5px; height:5px; border-radius:50%; background:#026670; opacity:0.5; flex-shrink:0;"></span>
                কার্যক্রম <span style="margin-left:auto; font-size:11px; color:#aaa;">›</span>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>


  <div class="container" style="margin-bottom: -150px;margin-top: -50px;">
    <div class="row">
      <div class="col-12 col-lg-4 col-md-4 col-sm-12" style="margin-top: -35px !important;">
        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner mainCarousel-inner">
            <div class="carousel-item mainCarouel-item" *ngFor="let image of images1; let i = index"
              [class.active]="i === 0">

              <a href="{{ image.src }}" [title]="image.alt">
                <div class="image-container" style="margin-bottom: 40px;">
                  <img [src]="image.src"
                    style="height: 150px; border: 5px solid #adacac; width: 100%; object-fit: cover;"
                    alt="Image {{ i+1 }}" class="popup-btn" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>


      <div class="col-12 col-lg-4 col-md-4 col-sm-12" style="margin-top: 95px !important;">
        <div class="single-team-box">
          <div class="single-blog-post badgeItem" style="border: 5px solid #316437;">
            <ng-container *ngIf="homepageLatestVideoUrl">
              <iframe [src]="homepageLatestVideoUrl | safe" class="w-100" style="max-height: 220px;" height="220"
                frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </ng-container>
            <ng-container *ngIf="!homepageLatestVideoUrl && Video[0]">
              <video class="w-100" style="max-height: 220px;" src="{{Video[0].VideoPath}}" controls></video>
            </ng-container>
          </div>
        </div>
      </div>


      <div class="col-12 col-lg-4 col-md-4 col-sm-12" style="margin-top: -35px !important;">
        <div class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner mainCarousel-inner">
            <div class="carousel-item mainCarouel-item" *ngFor="let image of images2; let i = index"
              [class.active]="i === 0">
              <a href="{{ image.src }}" [title]="image.alt">
                <div class="image-container" style="margin-bottom: 40px;">
                  <img [src]="image.src"
                    style="height: 150px; border: 5px solid #adacac; width: 100%; object-fit: cover;"
                    alt="Image {{ i+1 }}" class="popup-btn" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>



    </div>

  </div>








































  <section class="subscribe-wrap-area" style="font-family: 'Congenial' !important;">
    <div class="container">
      <div class="subscribe-wrap-inner-box">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-5 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3 style="font-family: 'Li Ador Noirrit SemiBold';">যোগাযোগের তথ্য</h3>
              <ul class="footer-contact-info contactFooter">

                <li>
                  <i class="flaticon-email"></i>
                  <span
                    style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">ই-মেইল</span><ng-container
                    *ngIf="MainData !=null"> <a href="mailto:atsdm106365@gmail.com"
                      style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">{{MainData.
                      Email
                      }}</a></ng-container>

                </li>
                <li>
                  <i class="flaticon-marker"></i>
                  <span style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">মাদ্রাসার
                    ঠিকানা</span>
                  <a href="#" target="_blank"
                    style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">ছোট
                    মহেশখালী,মহেশখালী, কক্সবাজার,চট্টগ্রাম</a>
                </li>

                <li>
                  <i class="flaticon-phone-call"></i>
                  <a href="tel:01309106365"
                    style="font-family: 'Li Ador Noirrit SemiBold'; font-size: 18px; font-weight: normal;">01309106365</a>
                </li>
                <!-- <div class="row single-footer-widget">
                 
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <h3 style="font-family: 'Congenial'; text-align: center;">Contact (Office)</h3>
                    <div class="row">
                       <div class="col-lg-6 col-md-6 col-sm-12">
                        
                        <ul class="footer-contact-info contactFooter">
                          <li>
                            <i class="flaticon-phone-call"></i>
                            <a href="tel:+88 01819-498512">{{MainData?.OfficePhone1}}</a>
                          </li>
                         
                        

                         
                        </ul>
                        

                       </div>
                       <div class="col-lg-6 col-md-6 col-sm-12">
                        <ul class="footer-contact-info contactFooter">
                          <li>
                            <i class="flaticon-phone-call"></i>
                            <a href="tel:+88 01933-234575">{{MainData?.OfficePhone2}}</a>
                          </li>
                        
                        </ul>
                        
                       </div>
                    </div>
                    
                  </div>
                </div> -->
              </ul>
            </div>
          </div>

          <div class="col-12 col-lg-3 col-md-6 col-sm-6" style="font-family: 'Congenial'">
            <div class="single-footer-widget">
              <h3 style="font-family: 'Li Ador Noirrit SemiBold';">প্রয়োজনীয় লিংক</h3>
              <div class="card my-1">
                <div class="card-body">
                  <a href="https://bmeb.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">বাংলাদেশ মাদ্রাসা শিক্ষা বোর্ড</a>
                </div>
              </div>
              <div class="card my-1">
                <div class="card-body">
                  <a href="http://iau.edu.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">ইসলামি আরবি বিশ্ববিদ্যালয়</a>
                </div>
              </div>
              <div class="card my-1">
                <div class="card-body">
                  <a href="http://dme.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">মাদ্রাসা শিক্ষা অধিদপ্তর</a>
                </div>
              </div>
              <div class="card my-1">
                <div class="card-body">
                  <a href="https://nctb.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">জাতীয় শিক্ষাক্রম ও পাঠ্যপুস্তক বোর্ড (এনসিটিবি)
                  </a>
                </div>
              </div>
              <div class="card my-1">
                <div class="card-body">
                  <a href="http://www.educationboardresults.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">বোর্ড রেজাল্ট
                  </a>
                </div>
              </div>
              <div class="card my-1">
                <div class="card-body">
                  <a href="https://tmed.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">মাদরাসা কারিগিরি শিক্ষা বোর্ড
                  </a>
                </div>
              </div>


              <div class="card my-1">
                <div class="card-body">
                  <a href="http://banbeis.gov.bd/" target="_blank" rel="noopener noreferrer"
                    class="list-group-item list-group-item-action text-center"
                    style="font-family: 'Li Ador Noirrit SemiBold';">বাংলাদেশ শিক্ষাতথ্য ও পরিসংখ্যান ব্যুরো
                    (ব্যানবেইস)</a>
                </div>
              </div>



            </div>
            <!-- <div class="single-footer-widget">
                            <h3 style="font-family: 'HindSiliguri';">Important Links </h3>
                            <ul class="footer-contact-info links" style="padding-left: 0 !important;">
                                <li>
                                    <a href="http://www.bmeb.gov.bd/" target="_blank" rel="noopener noreferrer">বাংলাদেশ
                                        মাদ্রাসা শিক্ষা বোর্ড</a>
                                </li>
                                <li>
                                    <a href="http://www.dme.gov.bd/" target="_blank" rel="noopener noreferrer">মাদ্রাসা
                                        শিক্ষা অধিদপ্তর</a>
                                </li>
                                <li>
                                    <a href="http://www.banbeis.gov.bd/" target="_blank"
                                        rel="noopener noreferrer">বাংলাদেশ
                                        শিক্ষাতথ্য ও পরিসংখ্যান ব্যুরো (ব্যানবেইস)</a>
                                </li>
                                <li>
                                    <a href="https://moedu.gov.bd/" target="_blank" rel="noopener noreferrer">শিক্ষা
                                        মন্ত্রণালয়</a>
                                </li>
                                <li>
                                    <a href="https://iau.edu.bd/" target="_blank" rel="noopener noreferrer">ইসলামি
                                        আরবি
                                        বিশ্ববিদ্যালয়</a>
                                </li>
                                <li>
                                    <a href="https://teachers.gov.bd/" target="_blank" rel="noopener noreferrer">শিক্ষক
                                        বাতায়ন</a>
                                </li>
                                <li>
                                    <a href="https://www.iu.ac.bd/" target="_blank" rel="noopener noreferrer">ইসলামি
                                        বিশ্ববিদ্যালয়</a>
                                </li>
                            </ul>
                        </div> -->
          </div>
          <div class="col-12 col-lg-4 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3 style="font-family: 'Li Ador Noirrit SemiBold';">প্রতিষ্ঠানের ম্যাপ</h3>
              <div class="googleMap">
                <iframe src="https://www.google.com/maps" class="w-100" height="450" style="border:0;"
                  allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>


              </div>
              <div class="socialMedia">
                <a href="https://www.facebook.com" target="_blank" rel="noopener"><img
                    src="assets/img/school/socialMedia/facebook.png" alt="facebook page" /></a>
                <a href="#" target="_blank" rel="noopener"><img src="assets/img/school/socialMedia/fb group.png"
                    alt="facebook group" /></a>
                <a href="#" target="_blank" rel="noopener"><img src="assets/img/school/socialMedia/youtube.png"
                    alt="youtube" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>